import React from "react";
import "./WrapErrorLoading.scss";
import gettext from "../utils/gettext";

export const Wrapper = ({
  full = false,
  children,
}: {
  children: React.ReactNode[] | React.ReactNode;
  full?: boolean;
}) => (
  <div className={`wrap-error-loading${full ? " full" : ""}`}>
    <p>{children}</p>
  </div>
);

export const Loading = (
  <Wrapper>
    <i className={`far fa-spinner fa-spin`} /> {gettext("Loading")}...
  </Wrapper>
);
export const LoadingFull = (
  <Wrapper full={true}>
    <i className={`far fa-spinner fa-spin`} /> {gettext("Loading")}...
  </Wrapper>
);
const l = {
  0: Loading,
  1: LoadingFull,
};

interface WrapErrorLoadingProps {
  error: any;
  children: () => JSX.Element | undefined | false;
  full?: boolean;
}
const WrapErrorLoading = ({ error, children, full = false }: WrapErrorLoadingProps) => (
  <div>{error ? <p>{gettext("Error occurred")}</p> : children() || l[full ? 1 : 0]}</div>
);

export default WrapErrorLoading;
